<script>
import candidateWizardApi from '@api/candidateWizard'

export default {

  props: {
    withProfile: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      candidate: null,
      profile: null,
      loading: true,
      error: '',
      expired: false
    }
  },

  created() {
    this.fetchCandidate()

    if (this.withProfile) {
      this.fetchProfile()
    }
  },

  methods: {
    fetchCandidate() {
      this.error = ''
      this.loading = true
      return candidateWizardApi.show()
        .then(response => {
          this.loading = false
          this.candidate = response
        })
        .catch(error => this.failed(error))
    },

    fetchProfile() {
      return candidateWizardApi.fetchProfile()
        .then(response => {
          this.loading = false
          this.profile = response
        })
        .catch(error => this.failed(error))
    },

    /**
     * An expired credential is a refusal, not a connection problem: say so,
     * and offer sign-in rather than a retry that can never succeed.
     */
    failed(error) {
      this.loading = false
      this.expired = !!(error && error.wizardCredentialExpired)
      this.error = this.expired
        ? 'Your sign-in has expired. Sign in again to continue.'
        : 'We could not load your candidate details. Check your connection or reopen your invitation, then try again.'
    }
  },

  render(h) {
    if (this.error) {
      const action = this.expired
        ? h('router-link', { props: { to: { name: 'candidate-wizard-sign-in' } }, class: 'accessible-button underline mt-4' }, 'Sign in')
        : h('button', {
          class: 'accessible-button underline mt-4', on: { click: () => { this.fetchCandidate(); if (this.withProfile) { this.fetchProfile() } } }
        }, 'Try again')
      return h('div', { attrs: { role: 'alert' }, class: 'p-6' }, [h('p', this.error), action])
    }
    return this.$scopedSlots.default({
      candidate: this.candidate,
      profile: this.profile,
      loading: this.loading
    })
  }
}
</script>
